import { Box } from '@material-ui/core';
import { Alert } from '@mui/material';
import React from 'react';
import { api_auth } from '../../../../common/globals/constants';
import { AtCircularProgress } from '../../../../components/AtCircularProgress';
import AvailabilityDowntime from '../../../../components/IndividualCharts/AvailabilityDowntime/AvailabilityDowntime';
import { useDynamicViewState } from '../../context/dynamic-view-context';
import { useFetchAvailabilityDowntime } from '../../hooks/useFetchAvailabilityDowntime';
import { format } from 'date-fns';

const URL_PARAMS = ({ objetivoId, periodo }) => {
  let fechaInicio = '';
  let fechaTermino = '';

  if (periodo.period === 'c' && periodo.statePeriod) {
    fechaInicio = format(new Date(periodo.statePeriod.startDate), 'yyyy-MM-dd');
    fechaTermino = format(new Date(periodo.statePeriod.endDate), 'yyyy-MM-dd');
  }

  const token = sessionStorage.getItem('key');
  const user = sessionStorage.getItem('user');
  const URL = new URLSearchParams();
  URL.append('objetivoId', objetivoId);
  URL.append('token', token);
  URL.append('key', api_auth);
  URL.append('horarioId', '0');
  URL.append('fechaInicio', fechaInicio);
  URL.append('fechaTermino', fechaTermino);
  URL.append('nodoId', '0');
  URL.append('user', user);
  URL.append('t', periodo.period);

  return URL;
};

export const AvailabilityDowntimeChart = React.memo(({ objetivoId }) => {
  const { filterPeriod, refreshTime } = useDynamicViewState();

  const { data, isLoading, error, isFetching } = useFetchAvailabilityDowntime({
    urlParams: URL_PARAMS({
      objetivoId,
      periodo: filterPeriod,
    }),
    fetchApi:
      filterPeriod.period === 'c'
        ? 'getDetalleDisponibilidadConsolidadaCustom'
        : 'getDetalleDisponibilidadConsolidada',
    refreshTime,
  });

  if (isLoading || isFetching) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight={200}
      >
        <AtCircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error">{error.message || 'Error loading data'}</Alert>
    );
  }

  return <AvailabilityDowntime externalData={data} />;
});
